<template>
    <button v-if="isActive()" :class="types[type] + ' ' + colors[color] + ' ' + pointer + ' ' + css" @click="click($event)" :title="title">
        <i :class="icons[icon]"></i>
        {{ label }}
    </button>
</template>
<script>
import Acceso from "../../util/acceso"
export default {
    name: "Button",
    props: {
        label: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "default"
        },
        color: {
            type: String,
            default: "default"
        },
        icon: {
            type: String,
            default: "default"
        },
        activationCode: {
            type: String,
            default: null
        },
        activation: {
            type: Boolean,
            default: null
        },
        noPointer: {
            type: Boolean,
            default: false
        },
        css: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            types: {
                default: "nj-button",
                icon: "nj-button icon",
            },
            colors: {
                default: "c-gray",
                dark_blue: "c-dark-blue",
                blue: "c-blue",
                green: "c-green",
                red: "c-red",
            },
            icons: {
                default: "mdi-arrow-right-bold",
                leftArrow: "mdi-arrow-left-bold",
                calendar: "mdi-calendar",
                info: "mdi-information",
                remove: "mdi-delete",
                cancel: "mdi-close",
                edit: "mdi-pencil",
                check: "mdi-check",
                review: "mdi-check-all",
                excel: "mdi-file-excel-box",
                email: "mdi-email",
                find: "mdi-file-find",
                add: "mdi-file-plus",
                attachment: "mdi-attachment",
                save: "mdi-content-save",
                doc: "mdi-file-document-box",
                pdf: "mdi-file-pdf-box",
                copy: "mdi-content-copy",
                transfer: "mdi mdi-transfer",
                cart: "mdi mdi-cart",
            }
        }
    },
    computed: {
        pointer() {
            return this.noPointer
                ? "noPointer"
                : ""
        }
    },
    methods: {
        click(event) {
            this.$emit("click", event)
        },
        setType() {
            return this.icon ? "nj-button icon" : "nj-button"
        },
        isActive() {
            let condition1 = this.activationCode != null ? Acceso.activarOpcion(this.activationCode) : true
            let condition2 = this.activation != null ? this.activation : true
            return condition1 && condition2
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.noPointer {
    cursor: default !important;
}

.noPointer * {
    cursor: default !important;
}
</style>